import {useRouteLoaderData} from '@remix-run/react'
import {getTranslation} from '~/localization/translation'
import type {RootLoaderResponse} from '~/types/index.js'

function Summary({title, children}: {title: string; children: string}) {
  return (
    <p className="mb-10">
      <strong>{title}</strong> {children}
    </p>
  )
}

function SectionHeadline({children}: {children: string}) {
  return <h3 className="mb-[24px] mt-[48px] text-[24px] font-extrabold leading-[31px]">{children}</h3>
}

export default function PostSlug() {
  const {language, hostname} = useRouteLoaderData('root') as RootLoaderResponse
  const translations = getTranslation(language)

  return (
    <div className="flex justify-center">
      <div className="content-container mx-auto mb-9 mt-10 text-[14px]">
        <h1 className="text-[48px] font-semibold leading-[58px] mobile:text-3xl">{translations.PrivacyPolicy.title}</h1>
        <hr className="mb-10 mt-10 h-1 w-full bg-gray-400" />
        <section className="text-[16px] leading-[22px] text-[#363636]">
          <p className="mb-[40px]">{translations.PrivacyPolicy.p1}</p>
          <p className="mb-[40px]">{translations.PrivacyPolicy.p2(hostname)}</p>
          <p className="mb-[40px]">{translations.PrivacyPolicy.p3}</p>
          <p className="mb-[40px]">{translations.PrivacyPolicy.p4}</p>
        </section>
        <hr className="mt-10 hidden h-1 w-full bg-gray-400 tablet:flex" />
        <section className="[&>ul]:ml-4 [&>ul]:list-disc">
          <SectionHeadline>{translations.PrivacyPolicy.header1}</SectionHeadline>
          <Summary title={translations.PrivacyPolicy.summary}>{translations.PrivacyPolicy.p5}</Summary>
          <p className="mb-[40px]">{translations.PrivacyPolicy.p6}</p>
          <p className="mb-[40px]">{translations.PrivacyPolicy.p7}</p>
          <p>{translations.PrivacyPolicy.p8}</p>
          <SectionHeadline>{translations.PrivacyPolicy.header2}</SectionHeadline>
          <Summary title={translations.PrivacyPolicy.summary}>{translations.PrivacyPolicy.p9}</Summary>
          <p className="mb-[40px]">{translations.PrivacyPolicy.p10}</p>
          <SectionHeadline>{translations.PrivacyPolicy.header3}</SectionHeadline>
          <Summary title={translations.PrivacyPolicy.summary}>{translations.PrivacyPolicy.p11}</Summary>
          <p className="mb-[20px]">{translations.PrivacyPolicy.p12}</p>
          <p>{translations.PrivacyPolicy.p13}</p>
          <ol className="mb-[40px]">
            <li>{translations.PrivacyPolicy.list1_item1}</li>
            <li>{translations.PrivacyPolicy.list1_item2}</li>
          </ol>
          <p className="mb-[20px]">{translations.PrivacyPolicy.p14}</p>
          <ul className="mb-[40px]">
            <li>{translations.PrivacyPolicy.list2_item1}</li>
            <li>{translations.PrivacyPolicy.list2_item2}</li>
            <li>{translations.PrivacyPolicy.list2_item3}</li>
            <li>{translations.PrivacyPolicy.list2_item4}</li>
            <li>{translations.PrivacyPolicy.list2_item5}</li>
          </ul>
          <p className="mb-[20px]">{translations.PrivacyPolicy.p15}</p>
          <ul className="mb-[40px]">
            <li>{translations.PrivacyPolicy.list3_item1}</li>
            <li>{translations.PrivacyPolicy.list3_item2}</li>
          </ul>
          <SectionHeadline>{translations.PrivacyPolicy.header4}</SectionHeadline>
          <Summary title={translations.PrivacyPolicy.summary}>{translations.PrivacyPolicy.p15_2}</Summary>
          <p>
            {translations.PrivacyPolicy.p16}
            <br />
            <br />
            <br />
            {translations.PrivacyPolicy.p17}
            <br />
            <br />
          </p>
          <ul>
            <li>{translations.PrivacyPolicy.list4_item1}</li>
            <li>{translations.PrivacyPolicy.list4_item2}</li>
            <li>{translations.PrivacyPolicy.list4_item3}</li>
            <li>{translations.PrivacyPolicy.list4_item4}</li>
            <li>{translations.PrivacyPolicy.list4_item5}</li>
            <li>{translations.PrivacyPolicy.list4_item6}</li>
            <li>{translations.PrivacyPolicy.list4_item7}</li>
            <li>{translations.PrivacyPolicy.list4_item8}</li>
            <li>{translations.PrivacyPolicy.list4_item9}</li>
          </ul>
          <p>
            {translations.PrivacyPolicy.p18}
            <br />
            <br />
            <br />
            {translations.PrivacyPolicy.p19}
            <br />
            <br />
            {translations.PrivacyPolicy.p20}
          </p>
          <SectionHeadline>{translations.PrivacyPolicy.header5}</SectionHeadline>
          <Summary title={translations.PrivacyPolicy.summary}>{translations.PrivacyPolicy.p21}</Summary>
          <p>{translations.PrivacyPolicy.p22}</p>
          <SectionHeadline>{translations.PrivacyPolicy.header6}</SectionHeadline>
          <Summary title={translations.PrivacyPolicy.summary}>{translations.PrivacyPolicy.p23}</Summary>
          <p>{translations.PrivacyPolicy.p24}</p>
          <p>{translations.PrivacyPolicy.p25}</p>

          <ul>
            <li>{translations.PrivacyPolicy.list5_item1}</li>
            <li>{translations.PrivacyPolicy.list5_item2}</li>
            <li>{translations.PrivacyPolicy.list5_item3}</li>
            <li>{translations.PrivacyPolicy.list5_item4}</li>
            <li>{translations.PrivacyPolicy.list5_item5}</li>
            <li>{translations.PrivacyPolicy.list5_item6}</li>
          </ul>
          <SectionHeadline>{translations.PrivacyPolicy.header7}</SectionHeadline>
          <Summary title={translations.PrivacyPolicy.summary}>{translations.PrivacyPolicy.p26}</Summary>
          <p>{translations.PrivacyPolicy.p27}</p>
          <p>{translations.PrivacyPolicy.p28}</p>
          <SectionHeadline>{translations.PrivacyPolicy.header8}</SectionHeadline>
          <Summary title={translations.PrivacyPolicy.summary}>{translations.PrivacyPolicy.p29}</Summary>
          <p>{translations.PrivacyPolicy.p30}</p>
          <p>{translations.PrivacyPolicy.p31}</p>
          <p>{translations.PrivacyPolicy.p32}</p>
          <p>{translations.PrivacyPolicy.p33}</p>
          <p>{translations.PrivacyPolicy.p34}</p>
          <SectionHeadline>{translations.PrivacyPolicy.header9}</SectionHeadline>
          <Summary title={translations.PrivacyPolicy.summary}>{translations.PrivacyPolicy.p35}</Summary>
          <p>{translations.PrivacyPolicy.p36}</p>
          <p>{translations.PrivacyPolicy.p37}</p>
          <p>{translations.PrivacyPolicy.p38}</p>
          <p>{translations.PrivacyPolicy.p39}</p>
          <SectionHeadline>{translations.PrivacyPolicy.header10}</SectionHeadline>
          <Summary title={translations.PrivacyPolicy.summary}>{translations.PrivacyPolicy.p40}</Summary>
          <p>{translations.PrivacyPolicy.p41}</p>
          <p>{translations.PrivacyPolicy.p42}</p>
          <p>{translations.PrivacyPolicy.p43}</p>
          <SectionHeadline>{translations.PrivacyPolicy.header11}</SectionHeadline>
          <Summary title={translations.PrivacyPolicy.summary}>{translations.PrivacyPolicy.p44}</Summary>
          <p>{translations.PrivacyPolicy.p45}</p>
          <p>{translations.PrivacyPolicy.p46}</p>
          <p>{translations.PrivacyPolicy.p47}: privacy@roundforest.com.</p>
          <p>{translations.PrivacyPolicy.p48}</p>
        </section>
      </div>
    </div>
  )
}
